export default __webpack_public_path__ + "static/media/electric-heater.5f1ac6d7.svg";